module.exports = __webpack_public_path__ + "static/img/getquotebgi.df06219a.jpg";